import { PADDING } from 'constants/sizes';

export const SIZES = Object.freeze({
  padding: { ...PADDING },
});
